<script lang="ts">
	import { getPricingContext } from '../../domain/pricing/pricingContext'
	import Icon from '../icon/Icon.svelte'
	import StructuredText from '../structuredText/StructuredText.svelte'
	import StructuredTextBlocks from '../structuredText/StructuredTextBlocks.svelte'
	import { isStructuredTextEmpty } from '../structuredText/structuredText'
	import Tooltip from '../tooltip/Tooltip.svelte'
	import { MembershipsV1PlatformId } from '@sdk/Api'
	import { InformationCircle } from '@steeze-ui/heroicons'
	import type { ListItemRecord, ListRecord } from 'datocms/models'

	interface Props {
		item: ListRecord
		small?: boolean
		large?: boolean
		cols?: boolean
	}

	let { item, small = false, large = false, cols = false }: Props = $props()

	const { integration } = getPricingContext() || { integration: null }

	function filterShopifyHidden(item: ListItemRecord) {
		return integration === MembershipsV1PlatformId.PLATFORM_ID_SHOPIFY
			? item.shopifyHidden !== true
			: true
	}
</script>

<ul class="{cols ? 'grid grid-cols-1 md:grid-cols-2' : 'flex flex-col'} gap-2.5">
	{#each item.content.filter(filterShopifyHidden) as listItem (listItem.id)}
		<li class="flex {small ? 'gap-[5px]' : large ? 'gap-3 md:gap-4' : 'gap-2.5'}">
			<div
				style={listItem.icon || listItem.iconLink?.image?.url
					? `background: url(${listItem.iconLink?.image?.url || listItem.icon.url}) no-repeat; background-size: 100%`
					: ''}
				class="flex shrink-0 items-center justify-center text-xs {small
					? 'h-3.5 w-3.5 -translate-y-px'
					: large
						? 'h-5 w-5 max-md:translate-y-0.5 md:h-7 md:w-7'
						: 'h-4 w-4'}"
			>
				{listItem.emojiIcon}
			</div>
			<div
				class="
					inline
					[&_a]:underline [&_a]:hover:no-underline [&_p]:inline
					{small ? 'text-xs leading-[14.4px]' : large ? 'text-lg md:text-2xl' : 'leading-4.5'}
				"
			>
				<StructuredTextBlocks structuredText={listItem.text} />

				{#if listItem.tooltip && !isStructuredTextEmpty(listItem.tooltip)}
					<div class="-my-0.5 inline-flex h-4 w-4 translate-y-0.5 items-center">
						<Tooltip>
							{#snippet placeholder()}
								<Icon outline small src={InformationCircle} />
							{/snippet}
							<div class="[&_a]:underline [&_a]:hover:no-underline">
								<StructuredText structuredText={listItem.tooltip.value} />
							</div>
						</Tooltip>
					</div>
				{/if}
			</div>
		</li>
	{/each}
</ul>
